//payload_Key
export const MC_OPT_JOIN_TIME = 'MC_OPT_JOIN_TIME';
export const MC_OPT_JOIN_TIME_REST = 'MC_OPT_JOIN_TIME_REST';

//store state
const initialState = {
  isEffectCanUpload: false, //是否有效可以上报【事件1：打开消息盒子、事件2：点击“待报名”筛选项、事件3：点击消息内的“查看详情”按钮、、、统计操作流程仅为“事件1-事件2-事件3”的完整时长】
  optTime: [], //Array<name: '打开弹窗',timePoint: Date.now()> 【name:行为名称，timePoint:时间点】
};

export const MC_OPT_JOIN_TIME_PAYLOAD_ENUM = {
  1: {
    step: 1,
    name: '打开弹窗',
  },
  2: {
    step: 2,
    name: '选中待报名',
  },
  3: {
    step: 3,
    name: '点击详情去报名',
  },
};

//更新行为记录
export function updateOptJoinTime(optItem) {
  return {
    type: MC_OPT_JOIN_TIME,
    payload: optItem,
  };
}

//重置行为，无效操作路径，不可作为依据统计上报
export function resetOptJoinTime() {
  return {
    type: MC_OPT_JOIN_TIME_REST,
  };
}

//reducer
export default function mcOptJoinTime(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case MC_OPT_JOIN_TIME: {
      return { isEffectCanUpload: true, optTime: [...(state?.optTime || []), payload] };
    }
    case MC_OPT_JOIN_TIME_REST: {
      return { ...initialState };
    }
    default: {
      return { ...state };
    }
  }
}
